import {
    LockOutlined,
    PoweroffOutlined,
    UserOutlined
} from "@ant-design/icons";
import {
    LoginForm,
    ProFormCheckbox,
    ProFormText,
} from "@ant-design/pro-components";
import {
    Avatar,
    Button,
    Empty,
    Form,
    Modal,
    Space,
    Spin,
    Tabs,
    Tag,
    Typography,
    message
} from "antd";
import { useEffect, useState } from "react";
import { goToProfile, setProfileLocal } from "../../utils/common";

import Title from "antd/es/typography/Title";
import { useAuth } from "../../hooks/useAuth";

const iconStyles = {
    color: "rgba(0, 0, 0, 0.2)",
    fontSize: "18px",
    verticalAlign: "middle",
    cursor: "pointer",
};

export default function LoginPage() {
    const [form] = Form.useForm();
    const { user, ...auth } = useAuth();
    const [forgotInfo, setForgotInfo] = useState({
        email: "",
        token: "",
    });
    const [selectedFranchise, setSelectedFranchise] = useState(null);

    const [loginType, setLoginType] = useState("login");

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        if (user.length > 0) setLoginType("profile");
    }, [user]);

    return (
        <div
            className="login-page"
            style={{
                backgroundColor: "white",
                display: "flex",
                backgroundImage: "url(/imgs/login-sidebackground.png)",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}
        >
            <img className="logo-login" src="/imgs/ArborSlogan.svg" alt="" />

            <div class="title-container">
                <Title className="title" level={1}>
                    Bem vindo
                </Title>
                <p className="phrase" style={{ color: "#fff" }}>
                    Transforme o seu conhecimento com a ARBOR. <br />
                    Faça login em sua conta e tenha acesso a nossa plataforma.
                </p>
            </div>

            <div
                style={{
                    width: "400px",
                    padding: "20px",
                    borderRadius: "9px",
                    backgroundColor: "#fff",
                    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
                    zIndex: 2,
                }}
            >
                <LoginForm
                    logo="/favicon.ico"
                    title="Arbor Idiomas"
                    subTitle="Seja bem vindo de volta !"
                    form={form}
                    submitter={{
                        searchConfig: {
                            submitText:
                                loginType === "login" ? "Entrar" : "Enviar",
                        },
                        submitButtonProps: {
                            size: "large",
                            style: {
                                width: "100%",
                            },
                        },
                    }}
                    onFinish={async (values) => {
                        form.validateFields().then(async (values) => {
                            if (loginType === "forgot") {
                                const status = auth.forgot(values.email);
                                Promise.resolve(status).then((res) => {
                                    if (res) {
                                        message.success(
                                            "Email enviado com sucesso!"
                                        );
                                        setForgotInfo(state => ({ ...state, email: values.email }));
                                        setLoginType("token");
                                    } else {
                                        message.error("Erro ao enviar email!");
                                    }
                                });
                            } else if (loginType === "token") {
                                const status = auth.token(forgotInfo.email, values.token);
                                Promise.resolve(status).then((res) => {
                                    if (res) {
                                        message.success(
                                            "Token validado com sucesso!"
                                        );
                                        setForgotInfo(state => ({ ...state, token: values.token }));
                                        setLoginType("changePassword");
                                    } else {
                                        message.error("Erro ao validar token!");
                                    }
                                });
                            } else if (loginType === "changePassword") {
                                const status = auth.changePassword(
                                    forgotInfo.email,
                                    forgotInfo.token,
                                    values.password,
                                    values.confirm_password
                                );
                                Promise.resolve(status).then((res) => {
                                    if (res) {
                                        message.success(
                                            "Senha alterada com sucesso!"
                                        );
                                        setLoginType("login");
                                    } else {
                                        message.error("Erro ao alterar senha!");
                                    }
                                });
                            } else {
                                auth.login(values.email, values.password);
                            }
                        });
                    }}
                >
                    <Spin spinning={auth.loading}>
                        {loginType === "profile" ? (
                            <>
                                <div
                                    style={{
                                        overflowY: "auto",
                                        padding: "10px 0",
                                        maxHeight: 200,
                                        borderRadius: "9px",
                                        marginBottom: 20,
                                        backgroundColor:
                                            "rgba(76, 31, 134, 0.048)",
                                    }}
                                >
                                    {user?.length > 0 &&
                                        user?.map((item) => {
                                            const isFranchiseOrFranchisee =
                                                item.type_company === 1 ? (
                                                    <Tag color="blue">
                                                        Franquia
                                                    </Tag>
                                                ) : (
                                                    <Tag color="red">
                                                        Franqueadora
                                                    </Tag>
                                                );

                                            return (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent:
                                                            "space-between",
                                                        alignItems: "center",
                                                        flexDirection: "row",
                                                        margin: "10px 0",
                                                        cursor: "pointer",
                                                    }}
                                                    className={`franchise-item  ${item?.id ===
                                                            selectedFranchise?.id
                                                            ? "selected-franchise"
                                                            : ""
                                                        }`}
                                                    onClick={() => {
                                                        setSelectedFranchise(
                                                            item
                                                        );
                                                        setIsModalOpen(true);
                                                    }}
                                                >
                                                    <Space>
                                                        <Avatar />
                                                        <h3>
                                                            {item?.nickname}
                                                        </h3>
                                                    </Space>

                                                    {isFranchiseOrFranchisee}
                                                </div>
                                            );
                                        })}
                                </div>

                                <Button
                                    type="primary"
                                    icon={<PoweroffOutlined />}
                                    size="large"
                                    style={{
                                        width: "100%",
                                        marginBottom: 10,
                                    }}
                                    onClick={() => {
                                        auth.logout();
                                        setLoginType("login");
                                        setSelectedFranchise(null);
                                    }}
                                >
                                    Escolher outra conta
                                </Button>
                            </>
                        ) : (
                            <>
                                <Tabs
                                    centered
                                    activeKey={
                                        loginType === "login"
                                            ? "login"
                                            : "forgot"
                                    }
                                    onChange={(activeKey) =>
                                        setLoginType(activeKey)
                                    }
                                >
                                    <Tabs.TabPane key={"login"} tab={"Login"} />
                                    <Tabs.TabPane
                                        key={"forgot"}
                                        tab={"Esqueci minha senha"}
                                    />
                                </Tabs>
                                {loginType === "login" && (
                                    <>
                                        <ProFormText
                                            name="email"
                                            fieldProps={{
                                                size: "large",
                                                prefix: (
                                                    <UserOutlined
                                                        className={"prefixIcon"}
                                                    />
                                                ),
                                            }}
                                            placeholder={"Email do usuário"}
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        "Email é obrigatório!",
                                                },
                                            ]}
                                            allowClear
                                        />

                                        <ProFormText.Password
                                            name="password"
                                            fieldProps={{
                                                size: "large",
                                                prefix: (
                                                    <LockOutlined
                                                        className={"prefixIcon"}
                                                    />
                                                ),
                                            }}
                                            placeholder={"*********"}
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        "Senha é obrigatória!",
                                                },
                                            ]}
                                        />

                                        <div
                                            style={{
                                                marginBlockEnd: 24,
                                            }}
                                        >
                                            <ProFormCheckbox
                                                noStyle
                                                name="autoLogin"
                                            >
                                                Lembrar de mim
                                            </ProFormCheckbox>
                                        </div>
                                    </>
                                )}
                                {loginType === "forgot" && (
                                    <>
                                        <ProFormText
                                            name="email"
                                            fieldProps={{
                                                size: "large",
                                                prefix: (
                                                    <UserOutlined
                                                        className={"prefixIcon"}
                                                    />
                                                ),
                                            }}
                                            placeholder={"Email do usuário"}
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        "Email é obrigatório!",
                                                },
                                            ]}
                                            allowClear
                                        />
                                    </>
                                )}
                                {loginType === "token" && (
                                    <>
                                        <ProFormText
                                            name="token"
                                            fieldProps={{
                                                size: "large",
                                                prefix: (
                                                    <LockOutlined
                                                        className={"prefixIcon"}
                                                    />
                                                ),
                                            }}
                                            placeholder={"Token"}
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        "Token é obrigatório!",
                                                },
                                            ]}
                                        />
                                    </>
                                )}
                                {loginType === "changePassword" && (
                                    <>
                                        <ProFormText.Password
                                            name="password"
                                            fieldProps={{
                                                size: "large",
                                                prefix: (
                                                    <LockOutlined
                                                        className={"prefixIcon"}
                                                    />
                                                ),
                                            }}
                                            placeholder={"Nova senha"}
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        "Nova senha é obrigatória!",
                                                },
                                            ]}
                                        />
                                        <ProFormText.Password
                                            name="confirm_password"
                                            fieldProps={{
                                                size: "large",
                                                prefix: (
                                                    <LockOutlined
                                                        className={"prefixIcon"}
                                                    />
                                                ),
                                            }}
                                            placeholder={"Confirme a senha"}
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        "Confirmação de senha é obrigatória!",
                                                },
                                                ({ getFieldValue }) => ({
                                                    validator(rule, value) {
                                                        if (
                                                            !value ||
                                                            getFieldValue(
                                                                "password"
                                                            ) === value
                                                        ) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject(
                                                            "As senhas não conferem!"
                                                        );
                                                    },
                                                }),
                                            ]}
                                        />
                                    </>
                                )}
                            </>
                        )}
                    </Spin>
                </LoginForm>
            </div>

            <Modal
                title={
                    <>
                        <h2>Perfis de acesso</h2>
                    </>
                }
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                cancelText="Sair"
                width={400}
                cancelButtonProps={{ style: { display: "none" } }}
                okButtonProps={{ style: { display: "none" } }}
            >
                <Spin spinning={modalLoading}>
                    <Typography style={{ marginBottom: "1em" }}>
                        {selectedFranchise?.roles?.length > 0 &&
                            "Selecione um perfil de acesso"}
                    </Typography>

                    {selectedFranchise?.roles?.length > 0 ? (
                        selectedFranchise?.roles?.map((profile) => {
                            const isStudent = profile.id === 5;

                            if (!isStudent) return null;

                            return (
                                <>
                                    <div
                                        className="profile-item"
                                        onClick={async (e) => {
                                            if (!isStudent) {
                                                message.error(
                                                    "Você não tem permissão para acessar o sistema"
                                                );

                                                setTimeout(() => {
                                                    window.location.href = `${process.env
                                                            .REACT_APP_GESTAO_URL
                                                        }?user=${JSON.stringify(
                                                            selectedFranchise
                                                        )}?profile=${JSON.stringify(
                                                            profile
                                                        )}`;
                                                }, 1000);

                                                return;
                                            }

                                            setModalLoading(true);

                                            try {
                                                const data = await goToProfile({
                                                    franchise_hash:
                                                        selectedFranchise?.hash,
                                                    role_id: profile?.id,
                                                });

                                                auth.setProfile({
                                                    ...selectedFranchise,
                                                    ...data,
                                                    role_id: profile?.id,
                                                });
                                                setProfileLocal({
                                                    ...selectedFranchise,
                                                    ...data,
                                                    role_id: profile?.id,
                                                });
                                            } catch (error) {
                                                console.log(error);
                                            } finally {
                                                setModalLoading(false);
                                            }
                                        }}
                                    >
                                        <UserOutlined fontSize={23} />
                                        <div className="profile-item-info">
                                            <Typography>
                                                {profile.title}
                                            </Typography>
                                            <span>{profile.role}</span>
                                        </div>
                                    </div>
                                </>
                            );
                        })
                    ) : (
                        <Empty description="Nenhum perfil encontrado" />
                    )}
                </Spin>
            </Modal>
        </div>
    );
}
